import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import type { Payout } from '@/types/payout';

export const fetchPayoutById = async (
  payoutId: string,
  includes: string[] = []
): Promise<Payout> => {
  const { data } = await api.get<Payout>(
    `/dashboard/payouts/${payoutId}?includes=${includes.join(',')}`
  );
  return data;
};

export const usePayoutQuery = (payoutId: string, includes: string[] = []) => {
  return useQuery<Payout, Error>({
    queryKey: ['payout', payoutId, includes],
    queryFn: () => fetchPayoutById(payoutId, includes),
    enabled: !!payoutId,
  });
};
